import styled from 'styled-components';
import { FaChartBar } from 'react-icons/fa';

export const FilterContainer = styled.div`
  width: 100%;
  box-shadow: none;
  background-color: #fff;
  &::before {
    height: 0;
  }

  & + div {
    margin-top: 2px;
  }
`;

export const FilterContent = styled.div`
  width: 60%;
  height: 64px;
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: center;
`;

export const Text = styled.div`
  width: 100%;
  height: 0.75rem;
  margin-bottom: 0.25rem;
  margin-left: 1rem;
  border-radius: 0.125rem;
  animation: skeleton-loading 1s linear infinite alternate;

  &:last-child {
    margin-bottom: 0;
    width: 80%;
  }

  @keyframes skeleton-loading {
    0% {
      background-color: hsl(216, 11%, 85%);
    }

    100% {
      background-color: hsl(216, 11%, 95%);
    }
  }
`;

export const CardContainer = styled.div`
  height: 56px;
  min-width: 120px;
  border: 1px solid #c4c6c9;
  border-radius: 16px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  display: flex;
  justify-content: 'center';
  align-items: 'center';

  & + & {
    margin-left: 8px;
  }
`;

export const CardContent = styled.div`
  width: 100%;
  height: 64px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  padding: 8px 0 16px 0;
`;

export const CardText = styled.div`
  width: 80%;
  height: 1rem;
  border-radius: 0.25rem;
  animation: skeleton-loading 1s linear infinite alternate;

  &:last-child {
    width: 40%;
  }

  @keyframes skeleton-loading {
    0% {
      background-color: hsl(216, 11%, 85%);
    }

    100% {
      background-color: hsl(216, 11%, 95%);
    }
  }
`;

export const TableContainer = styled.div`
  width: 90%;
  height: 100%;
  margin-left: 4px;
  margin-right: 4px;
  border: 1px solid #c4c6c9;
  border-radius: 16px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  overflow: hidden;
`;

export const TableContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0 16px 0;
`;

export const TableText = styled.div`
  width: 80%;
  height: 1rem;
  border-radius: 0.25rem;
  animation: skeleton-loading 1s linear infinite alternate;

  & + div {
    margin-top: 8px;
  }

  &:first-child {
    margin-top: 8px;
  }

  @keyframes skeleton-loading {
    0% {
      background-color: hsl(216, 11%, 85%);
    }

    100% {
      background-color: hsl(216, 11%, 95%);
    }
  }
`;

export const ResultsCardContainer = styled.div`
  width: 240px;
  height: 64px;
  border-radius: 16px;
  background-color: #fff;
  border: 1px solid #c4c6c9;
  display: flex;
  justify-content: 'center';
  align-items: 'center';

  & + div {
    margin-top: 1rem;
  }

  @media (max-width: 900px) {
    & + div {
      margin-top: 0px;
      margin-left: 0.5rem;
    }
  }
`;

export const ResultsCardContent = styled.div`
  width: 100%;
  height: 64px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;

  @media (max-width: 900px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

export const ResultsText = styled.div`
  width: 40%;
  height: 1rem;
  border-radius: 0.25rem;
  animation: skeleton-loading 1s linear infinite alternate;

  &:last-child {
    margin-bottom: 0;
    width: 30%;
  }

  @keyframes skeleton-loading {
    0% {
      background-color: hsl(216, 11%, 85%);
    }

    100% {
      background-color: hsl(216, 11%, 95%);
    }
  }

  @media (max-width: 900px) {
    width: 80%;

    &:last-child {
      margin-bottom: 0;
      margin-top: 8px;
      width: 40%;
    }
  }
`;

interface IChartContainerProps {
  width: number | string;
  height: number | string;
}

export const ChartContainer = styled.div<IChartContainerProps>`
  min-height: 240px;
  height: ${props => props.height}px;
  min-width: 360px;
  width: ${props => props.width}px;
  border-radius: 16px;
  box-shadow: 0px 4px 4px 2px rgba(0, 0, 0, 0.25);
  padding: 8px;
  overflow: hidden;
`;

export const ChartContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const ChartIcon = styled(FaChartBar)`
  width: 10rem;
  height: 10rem;
  animation: chart-skeleton 1s linear infinite alternate;

  @keyframes chart-skeleton {
    0% {
      color: hsl(216, 11%, 85%);
    }

    100% {
      color: hsl(216, 11%, 95%);
    }
  }
`;
